<template>
  <div class="animated fadeIn">
    <UsersSearchBar :title="$t('COMMON.USERS')" :roles="roles" :accounts="accounts" @filterInput="setFilter" @filterByAccount="filterByAccount" @filterByRole="filterByRole" />
    <b-row>
      <b-col lg="12">
        <b-table v-if="usersLoaded" hover striped show-empty :empty-text="$t('COMMON.NO_RECORD')" responsive="sm" :items="users" :fields="tableFields" :filter="filter">
          <template slot="HEAD_username" slot-scope="data"><em>{{ $t(data.label) }}</em></template>
          <template slot="username" slot-scope="data">
            <router-link id="users" :to="'/admin/users/' + data.item.id"> {{ data.value }}
            </router-link>
          </template>
          <template slot="HEAD_account_name" slot-scope="data"><em>{{ $t(data.label) }}</em></template>
          <template slot="account_name" slot-scope="data">
            <a v-if="!isSuperAdmin" > {{ data.value }} </a>
            <router-link v-else id="users" :to="'/super_admin/accounts/' + data.item.account_id"> {{ data.value }}
            </router-link>
          </template>
          <template slot="HEAD_role" slot-scope="data"><em>{{ $t(data.label) }}</em></template>
          <!-- <template slot="HEAD_team" slot-scope="data"><em>{{ $t(data.label) }}</em></template> -->
          <template slot="HEAD_edit_link" slot-scope="data"><em>{{ $t(data.label) }}</em></template>
          <template slot="edit_link" slot-scope="data" v-if="!(data.item.role ==='Admin' && isAdmin)">
            <b-button size="sm" v-if="data.item.status === 'ACTIVE'"
                      variant='success' @click="deactivateUser(data.item.id)"
                      v-b-tooltip.hover :title="$t('COMMON.DEACTIVATE')">
              {{ data.item.status }}
            </b-button>
            <router-link :to="'/admin/users/' + data.item.id" v-else>
              <b-button size="sm" variant='danger' v-b-tooltip.hover :title="$t('COMMON.ACTIVATE')">
                {{ data.item.status }}
              </b-button>
            </router-link>
            <b-button size="sm" v-if="data.item.is_blocked"
              variant='success' @click="unblockUser(data.item.id)"
              v-b-tooltip.hover :title="$t('COMMON.UNBLOCK')">
              UNBLOCK
            </b-button>
            <router-link :to="'/admin/users/' + data.item.id">
              <b-button class="ml-2" size="sm" variant="primary" v-b-tooltip.hover :title="$t('COMMON.EDT_USR')" v-if="checkAdmin(data.item)">{{$t('COMMON.EDIT').toUpperCase()}}</b-button>
            </router-link>
          </template>
        </b-table>
        <b-card v-else>
          <content-placeholders>
            <content-placeholders-img :style="{height: '400px'}" />
          </content-placeholders>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'
import router from '../../router'
import UsersSearchBar from '../../components/utils/UsersSearchBar'
export default {
  data () {
    return {
      usersLoaded: false,
      tableFields: [
        { key: 'id', sortable: true },
        { key: 'username', sortable: true, label: 'COMMON.NAME' },
        { key: 'email', sortable: true, label: 'Email' },
        { key: 'account_name', sortable: true, label: 'COMMON.ACCOUNT' },
        { key: 'role', sortable: true, label: 'USERS.ROLE' },
        // { key: 'team', sortable: false, label: 'TEAMS.TEAM' },
        { key: 'edit_link', sortable: false, label: 'COMMON.ACTIONS' }
      ],
      accounts: [],
      roles: [],
      users: [],
      filter: null,
      selected_user: null
    }
  },
  components: {
    UsersSearchBar
  },
  computed: {
    ...mapGetters(['idToken', 'isAdmin', 'isAdminRole', 'isSuperAdmin', 'accountId', 'currentUserId']),
    tempHide () {
      return false
    }
  },
  created () {
    if (this.isSuperAdmin) {
      Vue.axios.get('/admin/accounts/', {
        headers: { Authorization: `Bearer ${this.idToken}` }
      })
        .then(res => {
          this.accounts = ([{ text: 'All', value: -1 }]).concat(res.data.accounts.map(account => { return { text: account.name, value: account.id } }))
          this.roles = [{ text: 'Admin', value: 2 }, { 'text': 'Super Admin', value: 1 }]
        })
    } else if (this.isAdmin) {
      this.getRolesByAccount(this.accountId)
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      if (vm.isAdminRole) {
        var accountId = -1
        var roleId = vm.isSuperAdmin ? 2 : -1
        Vue.axios.get('/admin/users/users_by_roles?role_id=' + roleId + '&account_id=' + accountId, {
          headers: {
            Authorization: `Bearer ${vm.idToken}`,
            'Cache-Control': 'no-cache, no-store',
            'Pragma': 'no-cache',
            'Expires': '0'
          }
        })
          .then(res => {
            vm.users = res.data.users
            vm.usersLoaded = true
            next()
          })
          .catch(error => {
            if (error.status === 401) {
              Vue.toasted.show(vm.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' })
              console.log(this.$t('COMMON.MSG_EXPIRED'))
            } else {
              Vue.toasted.show(vm.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' })
              next(false)
            }
          })
      } else {
        router.replace('/Not-Found-404')
      }
    })
  },
  methods: {
    setFilter (filter) {
      this.filter = filter
    },
    filterByAccount (accountId, roleId) {
      if (accountId === -1) {
        this.roles = [{ text: 'Admin', value: 2 }, { 'text': 'Super Admin', value: 1 }]
      } else {
        this.getRolesByAccount(accountId)
      }
      this.fetchUsers(accountId, roleId)
    },
    filterByRole (accountId, roleId) {
      this.fetchUsers(accountId, roleId)
    },
    getRolesByAccount (accountId) {
      Vue.axios.get('/admin/users/' + accountId + '/account_roles/', {
        headers: {
          Authorization: `Bearer ${this.idToken}`,
          'Cache-Control': 'no-cache, no-store',
          'Pragma': 'no-cache',
          'Expires': '0'
        }
      })
        .then(res => {
          this.roles = ([{ text: 'All', value: -1 }]).concat(res.data.roles.map(role => { return { text: this.$options.filters.titlize(role.name), value: role.id } }))
        })
        .catch(error => {
          if (error.status === 401) {
            Vue.toasted.show(this.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' })
            console.log(this.$t('COMMON.MSG_EXPIRED'))
          } else {
            Vue.toasted.show(this.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' })
          }
        })
    },
    fetchUsers (accountId, roleId) {
      this.usersLoaded = false
      this.filter = ''
      Vue.axios.get('/admin/users/users_by_roles?role_id=' + roleId + '&account_id=' + accountId, {
        headers: {
          Authorization: `Bearer ${this.idToken}`,
          'Cache-Control': 'no-cache, no-store',
          'Pragma': 'no-cache',
          'Expires': '0'
        }
      })
        .then(res => {
          this.users = res.data.users
          this.usersLoaded = true
        })
        .catch(error => {
          if (error.status === 401) {
            Vue.toasted.show(this.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' })
          } else {
            Vue.toasted.show(this.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' })
          }
        })
    },
    confirmDeleteUser (data) {
      this.selected_user = data.item.id
      this.$refs.deleteUserModal.show()
    },
    cancelDelete () {
      this.selected_user = null
    },
    deleteUser () {
      if (this.selected_user) {
        Vue.axios.delete('/admin/users/' + this.selected_user, { headers: { Authorization: `Bearer ${this.idToken}` } })
          .then(res => {
            if (res.data.success) {
              this.users = this.users.filter(function (user) { return user.id !== res.data.id })
              Vue.toasted.show(res.data.msg)
            } else {
              Vue.toasted.show(res.data.msg, { icon: 'chain-broken', type: 'error' })
            }
          })
          .catch(error => {
            if (error.status === 401) {
              Vue.toasted.show(this.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' })
              console.log(this.$t('COMMON.MSG_EXPIRED'))
            } else {
              Vue.toasted.show(this.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' })
            }
          })
      }
    },
    deactivateUser (userId) {
      Vue.axios.post('/admin/users/' + userId + '/deactivate', {}, { headers: { Authorization: `Bearer ${this.idToken}` } })
        .then(res => {
          if (res.data.success) {
            this.users = this.users.map(function (user) {
              if (user.id === userId) {
                user['status'] = 'INACTIVE'
              }
              return user
            })
            Vue.toasted.show(res.data.msg)
          } else {
            Vue.toasted.show(res.data.msg, { icon: 'chain-broken', type: 'error' })
          }
        })
        .catch(error => {
          if (error.status === 401) {
            Vue.toasted.show(this.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' })
            console.log(this.$t('COMMON.MSG_EXPIRED'))
          } else {
            Vue.toasted.show(this.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' })
          }
        })
    },
    unblockUser (userId) {
      Vue.axios.post('/admin/users/' + userId + '/unblock', {}, { headers: { Authorization: `Bearer ${this.idToken}` } })
        .then(res => {
          if (res.data.success) {
            this.users = this.users.map(function (user) {
              if (user.id === userId) {
                user['is_blocked'] = false
              }
              return user
            })
            Vue.toasted.show(res.data.msg)
          } else {
            Vue.toasted.show(res.data.msg, { icon: 'chain-broken', type: 'error' })
          }
        })
        .catch(error => {
          if (error.status === 401) {
            Vue.toasted.show(this.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' })
            router.replace('/sign_in')
          } else {
            Vue.toasted.show(this.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' })
          }
        })
    },
    checkAdmin (data) {
      return (data.role !== 'Super Admin' || this.isSuperAdmin)
    }
  }
}
</script>

<style lang="scss" scoped>
.create-btn {
  text-align: right;
  margin-bottom: 10px;
}

.tabs .tab-content .tab-pane {
  padding: 0;
}

.users-tab {
  color: white !important;

  &.user {
    background-color: #63c2de !important;
  }

  &.role {
    background-color: #20a8d8 !important;
  }

  &.active {
    color: inherit !important;
    background-color: white !important;
  }
}

.delete-warning {
  font-size : 1rem;
  color: red;
}

#users {
  color: black ;
}

#users:hover {
  text-decoration: underline;
}
</style>



// WEBPACK FOOTER //
// src/views/admin/users.vue